<template>
    <!-- infos -->
        <section class="view-container  infos" id="modes">


            <div class="kyogre-content">
                <img src="images/kyogre2.png" class="kyogre kyogre2" alt="kyogre">
                <img src="images/kyogre1.png" class="kyogre" alt="kyogre">
            </div>

            <div class="sunwater-content">
                <div class="container-sunwater container-sunwater-1">
                    <img src="images/sun-water.png" class="sun-water" alt="sun underwater">
                </div>
                <div class="container-sunwater container-sunwater-2">
                    <img src="images/sun-water.png" class="sun-water" alt="sun underwater">
                </div>
                <div class="container-sunwater container-sunwater-3">
                    <img src="images/sun-water.png" class="sun-water" alt="sun underwater">
                </div>
                <div class="container-sunwater container-sunwater-4">
                    <img src="images/sun-water.png" class="sun-water" alt="sun underwater">
                </div>
            </div>


            <div class="content-buble-une">
                <div class="content-buble">
                    <div class="bulle-content  bulle-une">
                        <img src="images/buble.png" class="bulle bulle-1" alt="bulle">
                    </div>
                    <div class="bulle-content  bulle-deux">
                        <img src="images/buble.png" class="bulle bulle-2" alt="bulle">
                    </div>
                    <div class="bulle-content  bulle-trois">
                        <img src="images/buble.png" class="bulle bulle-3" alt="bulle">
                    </div>
                    <div class="bulle-content  bulle-quatre">
                        <img src="images/buble.png" class="bulle bulle-4" alt="bulle">
                    </div>
                </div>
            </div>

            <div class="content-buble-deux">
                <div class="content-buble">
                    <div class="bulle-content  bulle-une">
                        <img src="images/buble.png" class="bulle bulle-1" alt="bulle">
                    </div>
                    <div class="bulle-content  bulle-deux">
                        <img src="images/buble.png" class="bulle bulle-2" alt="bulle">
                    </div>
                    <div class="bulle-content  bulle-trois">
                        <img src="images/buble.png" class="bulle bulle-3" alt="bulle">
                    </div>
                    <div class="bulle-content  bulle-quatre">
                        <img src="images/buble.png" class="bulle bulle-4" alt="bulle">
                    </div>
                </div>
            </div>

            <div class="content-buble-trois">
                <div class="content-buble">
                    <div class="bulle-content  bulle-une">
                        <img src="images/buble.png" class="bulle bulle-1" alt="bulle">
                    </div>
                    <div class="bulle-content  bulle-deux">
                        <img src="images/buble.png" class="bulle bulle-2" alt="bulle">
                    </div>
                    <div class="bulle-content  bulle-trois">
                        <img src="images/buble.png" class="bulle bulle-3" alt="bulle">
                    </div>
                    <div class="bulle-content  bulle-quatre">
                        <img src="images/buble.png" class="bulle bulle-4" alt="bulle">
                    </div>
                </div>
            </div>
            
            <div class="content-buble-quatre">
                <div class="content-buble">
                    <div class="bulle-content  bulle-une">
                        <img src="images/buble.png" class="bulle bulle-1" alt="bulle">
                    </div>
                    <div class="bulle-content  bulle-deux">
                        <img src="images/buble.png" class="bulle bulle-2" alt="bulle">
                    </div>
                    <div class="bulle-content  bulle-trois">
                        <img src="images/buble.png" class="bulle bulle-3" alt="bulle">
                    </div>
                    <div class="bulle-content  bulle-quatre">
                        <img src="images/buble.png" class="bulle bulle-4" alt="bulle">
                    </div>
                </div>
            </div>
            <div class="view-content">
                <input type="radio" name="modes" class="input-modes" id="modes-mode" checked>
                <input type="radio" name="modes" class="input-modes" id="modes-lieux">
                <input type="radio" name="modes" class="input-modes" id="modes-pokemon">
                <input type="radio" name="modes" class="input-modes" id="modes-difficultes">
                <article class="infos-container">
                    <div class="zone-cta-info">
                        <label class="cta-container  cta-container--modes" for="modes-mode">
                            <span class="cta">
                                Modes de jeu
                            </span>
                        </label>
                        <label class="cta-container  cta-container--lieux" for="modes-lieux">
                            <span class="cta">
                                Des lieux mémorables
                            </span>
                        </label>
                        <label class="cta-container  cta-container--pokemon" for="modes-pokemon">
                            <span class="cta">
                                Plus de POKéMON
                            </span>
                        </label>
                        <label class="cta-container  cta-container--difficultes" for="modes-difficultes">
                            <span class="cta">
                                Plus de challenges
                            </span>
                        </label>

                        <!-- 
                        <div class="cta-container">
                            <a href="#modes" class="cta">
                                Modes de jeu
                            </a>
                        </div>
                        
                        <div class="cta-container">
                            <a href="#modes" class="cta">
                                Modes de jeu
                            </a>
                        </div>
                        
                        <div class="cta-container">
                            <a href="#modes" class="cta">
                                Modes de jeu
                            </a>
                        </div> -->
                    </div>
                        <div class="une-info une-info--lieux">
                            <h2 class="titre-pokeball">
                                <img src="images/pokeball.svg" class="pokeball" alt="pokéball">Des endroits hors du commun&nbsp;!
                            </h2>
                            <div class="zone-text">
                                <p class="text">
                                    Partez à la découverte d’un <span class="bold">monde vaste et immersif</span>, composé de régions inédites aux <span class="bold">ambiances et identités fortes</span>. 
                                    Chaque zone recèle ses propres histoires, ses environnements singuliers et des <span class="bold">POKéMON rares</span> que seuls <span class="bold">les voyageurs les plus curieux</span> auront la chance d’apercevoir.
                                    <br/><br/>
                                    Des métropoles animées aux <span class="bold">sanctuaires oubliés</span>, des routes paisibles aux terres sauvages et imprévisibles, chaque lieu dévoile ses <span class="bold">secrets, quêtes et mystères</span> au fil de votre progression.
                                    <br/><br/>
                                    POKéMON Opale vous invite à explorer des <span class="bold">destinations fascinantes</span>, où rêve et réalité s’entremêlent. 
                                    Que vous soyez en <span class="bold">quête d’évasion</span>, d’aventure ou de découvertes surprenantes, <span class="bold">chaque région promet de vous émerveiller</span> et d’enrichir votre voyage.
                                </p>
                            </div>
                        </div>

                    <div class="une-info une-info--pokemon">
                        <h2 class="titre-pokeball">
                            <img src="images/pokeball.svg" class="pokeball" alt="pokéball">Une multitude de POKéMON et d'équipes différentes&nbsp;!
                        </h2>
                        <div class="zone-text">
                            <p class="text">
                                Partez à l’aventure avec plus de <span class="bold">600 POKéMON</span> et façonnez des équipes aussi variées que puissantes. 
                                Chaque région propose ses propres rencontres et découvertes, ouvrant la voie à <span class="bold">d’innombrables combinaisons</span> pour créer l’équipe qui vous ressemble.
                                <br/><br/>
                                Que vous aimiez les <span class="bold">stratégies offensives, défensives ou polyvalentes</span>, POKéMON Opale vous offre la liberté totale de bâtir 
                                <span class="bold">l’équipe de vos rêves</span>. <span class="bold">Analysez les défis</span> à venir, adaptez-vous, expérimentez et trouvez les synergies parfaites pour triompher de chaque situation.
                                <br/><br/>
                                À vous de composer, d’ajuster et de <span class="bold">perfectionner votre formation</span> pour relever tous les défis du monde d’Opale.
                            </p>
                        </div>
                    </div>

                    <div class="une-info  une-info--modes">
                        <h2 class="titre-pokeball">
                            <img src="images/pokeball.svg" class="pokeball" alt="pokéball">Des façons de jouer extraordinaires&nbsp;!
                        </h2>
                        <div class="zone-text">
                            <p class="text">
                                <span class="bold">POKéMON Opale</span> multiplie les expériences et propose <span class="bold">une variété de modes et de mécaniques</span> pensées pour renouveler votre façon de jouer. 
                                Que vous aimiez l’exploration, le défi, <span class="bold">la stratégie ou la collection</span>, chaque système enrichit votre progression et rend votre <span class="bold">aventure unique</span>.
                                <br/><br/>
                                Ajustez votre aventure grâce aux <span class="bold">niveaux de difficulté</span>, ou créez votre propre expérience avec le <span class="bold">mode de difficulté personnalisé</span>. 
                                Les arènes sont entièrement repensées, <span class="bold">chacune avec ses règles, ses mécaniques et son identité</span>, pour offrir de véritables combats de maître.
                                <br/><br/>
                                Le chemin des deux héros, leurs choix et leur progression façonnent aussi votre partie&nbsp;: <span class="bold">exploration libre entre plusieurs régions</span>, défis uniques, artefacts légendaires, Essences à maîtriser et rencontres scénarisées transforment votre parcours en une <span class="bold">histoire vivante</span>.
                                <br/><br/>
                                <span class="bold">Explorez</span>, <span class="bold">combattez</span>, <span class="bold">collectionnez et évoluez</span> comme jamais auparavant.<br/>
                                Venez écrire votre propre légende.
                            </p>
                        </div>
                    </div>
                    <div class="une-info une-info--difficultes">
                        <h2 class="titre-pokeball">
                            <img src="images/pokeball.svg" class="pokeball" alt="pokéball">Relevez des défis toujours plus grands&nbsp;!
                        </h2>
                        <div class="zone-text">
                            <p class="text">
                                Dans <span class="bold">POKéMON Opale</span>, vous avez le contrôle total sur votre aventure grâce à un système complet de <span class="bold">niveaux de difficulté</span>. 
                                Que vous soyez un nouveau dresseur ou un expert en quête de challenge, chaque mode ajuste <span class="bold">l’intensité des combats et le rythme de votre progression</span>.
                                <br/><br/>
                                Pour les joueurs souhaitant aller encore plus loin, Opale propose une <span class="bold">difficulté personnalisée</span> permettant de modifier en profondeur 
                                les règles, les contraintes et les mécaniques du jeu. À vous de <span class="bold">choisir vos propres limites</span> et d’adapter le monde à votre style.
                                <br/><br/>
                                Qu’il s’agisse d’une aventure détendue ou d’un parcours exigeant, POKéMON Opale vous permet de <span class="bold">jouer à votre rythme</span>, 
                                tout en relevant des <span class="bold">défis toujours plus grands</span> à mesure que vous progressez.
                            </p>
                        </div>
                    </div>

                </article>
                <article class="pokedex">
                    <div class="screen-pokedex">
                        <div class="pokedex-slider">
                            <img id="poke-current" class="poke-img" src=""  loading="lazy" alt="">
                            <img id="poke-next" class="poke-img" src="" loading="lazy" alt="">
                        </div>

                    </div>
                    <img src="images/pokedex-green.png" class="pokedex-img  pokedex-img--green" alt="Pokédex">
                    <img src="images/pokedex-green-light.png" class="pokedex-img  pokedex-img--green-light"  alt="Pokédex">
                    <img src="images/pokedex-onde.png"  class="pokedex-img  pokedex-img--ondes"  alt="Pokédex">
                    <img src="images/pokedex11.png"      class="pokedex-img"  alt="Pokédex">
                    <img src="images/pokedex-light.png" class="pokedex-img  pokedex-img--light"  alt="Pokédex">
                </article>
            </div>
        </section>
    <!-- infos -->
</template>

<script>
export default {
    name: "Infos",

    data() {
        return {
            pokemon_list: [
                "001", "002", "004", "005", "007", "008", "010", "011", "013", "014",
                "016", "017", "019", "021", "023", "027", "029", "030", "032", "033",
                "041", "042", "043", "046", "048", "050", "052", "054", "056", "058",
                "060", "061", "063", "066", "067", "069", "072", "074", "075", "077",
                "079", "081", "083", "084", "086", "088", "090", "092", "095", "098",
                "100", "102", "104", "109", "111", "116", "118", "120", "129", "133",
                "138", "140", "147", "152", "153", "155", "156", "158", "159", "161",
                "163", "165", "167", "170", "172", "173", "174", "175", "177", "179",
                "180", "182", "183", "185", "187", "190", "191", "193", "194", "198",
                "200", "202", "204", "206", "209", "211", "213", "215", "216", "218",
                "220", "222", "223", "225", "227", "228", "231", "234", "235", "236",
                "238", "239", "240", "246", "252", "253", "255", "256", "258", "259",
                "261", "263", "265", "266", "268", "270", "273", "276", "278", "280",
                "283", "285", "287", "290", "293", "296", "298", "299", "300", "302",
                "303", "304", "307", "309", "311", "312", "313", "314", "316", "318",
                "320", "322", "325", "327", "328", "331", "333", "336", "339", "341",
                "343", "345", "347", "349", "353", "355", "357", "359", "360", "361",
                "363", "366", "369", "371", "374", "377", "387", "388", "390", "391",
                "393", "394", "396", "398", "399", "401", "403", "405", "408", "410",
                "412", "415", "418", "420", "422", "425", "427", "431", "433", "434",
                "436", "439", "441", "442", "443", "447", "449", "451", "453", "456",
                "459", "479", "495", "496", "498", "499", "501", "502", "504", "506",
                "509", "511", "513", "515", "517", "519", "522", "524", "527", "529",
                "531", "535", "536", "538", "539", "540", "543", "546", "548", "550",
                "554", "556", "557", "559", "561", "562", "564", "566", "568", "570",
                "572", "574", "577", "580", "582", "585", "587", "588", "590", "592",
                "594", "595", "597", "599", "602", "605", "607", "610", "613", "616",
                "618", "619", "622", "624", "627", "629", "631", "632", "636", "639",
                "641", "643", "645"
            ]
        };
    },

    mounted() {
        const img = new Image();
        img.loading = "lazy";
        const path = "images/pokedex/";

        const current = document.getElementById("poke-current");
        const next = document.getElementById("poke-next");

        const randomImage = () => {
            const num = this.pokemon_list[
                Math.floor(Math.random() * this.pokemon_list.length)
            ];
            return `${path}${num}.png`;
        };

        // Première image
        current.src = randomImage();
        current.style.transform = "translate(-50%, -50%) translateX(0%)";

        const animate = () => {
            const newSrc = randomImage();

            // Place la nouvelle image hors écran à droite
            next.src = newSrc;
            next.style.transform = "translate(-50%, -50%) translateX(100%)";

            // Force reflow
            void next.offsetWidth;

            // Transition : slide
            current.style.transform = "translate(-50%, -50%) translateX(-100%)";
            next.style.transform = "translate(-50%, -50%) translateX(0%)";

            setTimeout(() => {
                // Swap
                current.src = newSrc;

                // Reset instantané sans transition
                current.style.transition = "none";
                next.style.transition = "none";

                current.style.transform = "translate(-50%, -50%) translateX(0%)";
                next.style.transform = "translate(-50%, -50%) translateX(100%)";

                // Réactive les transitions
                setTimeout(() => {
                    current.style.transition = "transform 0.5s ease-in-out";
                    next.style.transition = "transform 0.5s ease-in-out";
                }, 20);

            }, 500);
        };

        setInterval(animate, 3000);
    }
};
</script>


<style scoped>    
    .infos{
        width:100%;
        position: relative;
        z-index: 1;
        background-color: #13598c;
        background-image: url(/public/images/header-back.png);
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
    }
    .view-content{
        display: flex;
        justify-content: center;
        align-items: center;
        width: calc(100% - 82px);
        max-width: 1600px;
        margin: auto;
        background: #09275047;
        backdrop-filter: blur(3px);
        -webkit-backdrop-filter: blur(10px);
        border-radius: 50px;
        padding: 40px 40px;
        padding-top: 150px;
        border: solid 1px #0c307e6b;
    }
    .kyogre-content{
        width: 40%;
        position: absolute;
        top: 110px;
        animation: kyogre 6s infinite;
        max-width: 700px;
    }
    .kyogre{
        width: 100%;
        position: absolute;
    }
    .kyogre2{
        animation: kyogreoeil 6s infinite;
    }

    @keyframes kyogre {
        0% {
            transform: translateY(0px);
        }
        50% {
            transform: translateY(20px);
        }
        100% {
            transform: translateY(0px);
        }
    }
    @keyframes kyogreoeil {
        0% {
            opacity: 0.6;
        }
        50% {
            opacity:0.2;
        }
        100% {
            opacity: 0.6;
        }
    }

    .sunwater-content{
        width: 100%;
        position: absolute;
        top: -10%;
        right: -500px;
        pointer-events: none;
        transform: rotate(15deg)
    }
    .container-sunwater{
        width: 30%;
        position: absolute;
        top: -50px;
        right: 0;
        animation: sunwater 6s infinite cubic-bezier(0.73, 0.23, 0.21, 0.67);
    }
    .container-sunwater-2{
        right: 7%;
        filter: blur(2px);
        animation-delay: 2s;
        animation-duration: 5.2;
    }
    .container-sunwater-3{
        right: 5%;
        filter: blur(4px);
        animation-delay: 4s;
        animation-duration: 7s;
    }
    .container-sunwater-4{
        right: 2%;
        filter: blur(1px);
        animation-delay: 1s;
        animation-duration: 6.5s;
    }
    @keyframes sunwater {
        0% {
            transform: translateX(0px);
            filter: blur(2px);
        }
        25% {
            filter: blur(10px);
        }
        50% {
            filter: blur(2px);
            transform: translateX(50px);
        }
        75% {
            filter: blur(10px);
        }
        100% {
            transform: translateX(0px);
            filter: blur(2px);
        }
    }

    .content-buble-une{
        position: absolute;
        width: 0px;
        bottom: 0;
        left:10%;
        pointer-events: none;
        animation: buble-raise-up 3s infinite linear;
        animation-delay: 0.8s;
    }
    .content-buble-deux{
        position: absolute;
        width: 0px;
        bottom: 0;
        left:20%;
        pointer-events: none;
        animation: buble-raise-up 3s infinite linear;
        animation-delay: 2.2s;
    }
    .content-buble-trois{
        position: absolute;
        width: 0px;
        bottom: 0;
        left:50%;
        pointer-events: none;
        animation: buble-raise-up 3s infinite linear;
    }
    .content-buble-quatre{
        position: absolute;
        width: 0px;
        bottom: 0;
        left:80%;
        pointer-events: none;
        animation: buble-raise-up 3s infinite linear;
        animation-delay: 1.6s;
    }
    @keyframes buble-raise-up {
        0% {
            transform: translateY(0px);
            width:0px;
        }
        10% {
            width:40px;
            opacity:1;
        }
        90% {
            width:40px;
            opacity:1;
        }
        100% {
            transform: translateY(-1000px);
            opacity:0;
            width:60px;
        }
    }
    .bulle-content{
        position: absolute;
        width: 100%;
        height: 100%;
        top:0;
        left:50%;
        pointer-events: none;
    }
    .bulle{
        position: absolute;
        opacity:0.5;
        width: 20px;
        animation: buble-move 1s infinite linear;
    }
    .bulle-une{
        animation: buble-raise 3s infinite linear;
        width: 50%;
    }
    .bulle-deux{
        animation: buble-raise 2.5s infinite linear;
        width: 45%;
    }
    .bulle-trois{
        animation: buble-raise 3.5s infinite linear;
        width: 35%;
    }
    .bulle-quatre{
        animation: buble-raise 2s infinite linear;
        width: 22%;
    }
    .bulle-1{
        animation-duration: 2.3s;
    }
    .bulle-2{
        animation-duration: 1.6s;
    }
    .bulle-3{
        animation-duration: 2.1s;
    }
    .bulle-3{
        animation-duration: 4s;
    }
    @keyframes buble-move {
        0% {
            transform: rotate(45deg) translatex(-100%);
            width: 100%;
        }
        25%{
            width: 120%;
        }
        50% {
            transform: rotate(-45deg) translatex(100%);
            width: 100%;
        }
        75%{
            width: 120%;
        }
        100% {
            transform: rotate(45deg) translatex(-100%);
            width: 100%;
        }
    }
    @keyframes buble-raise {
        0% {
            opacity: 0;
            transform: translatex(500%);
        }
        10%{
            opacity: 0.5;
        }
        25%{
            opacity: 1;
            transform: translatex(-500%);
        }
        50%{
            opacity: 1;
            transform: translatex(500%);
        }
        75%{
            transform: translatex(-500%);
        }
        90%{
            opacity: 0.5;
        }
        100% {
            opacity: 0;
            transform: translatex(500%);
        }
    }
    .view-container{
        padding-bottom: 150px;
        overflow: hidden;
        box-shadow: inset 0 50px 50px -25px rgba(0, 0, 0, 0.4)
    }
    .pokedex{
        position: relative;
        width: 428px;
        height: 673px;
        overflow: hidden;
        left: -20px;
    }
    .pokedex-img {
        position: absolute;
    }
    .pokedex-img--green-light{
        animation: clignotement 2s infinite;
    }
    .pokedex-img--light{
        animation: clignotement 1s infinite;
    }
    .pokedex-img--ondes{
        animation: defilement 8s linear infinite;
    }
    .screen-pokedex{
        width: 280px;
        height: 250px;
        position: absolute;
        top: 190px;
        left: 90px;
        background: white;
    }
    .screen-opale{
        width: 100%;
        position: absolute;
    }
    .infos-container{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        background: #d51f3e;
        border-radius: 20px 0 0 20px;
        padding: 0 20px;
        gap: 20px;
        filter: drop-shadow(2px 4px 6px black);
    }
    .une-info{
        width: 100%;
        max-width: 600px;
        background: #fafafa;
        border-radius: 20px 0 0 20px;
        padding: 60px 50px;
    }
    .zone-cta-info{
        display: flex;
        gap: 20px;
        flex-direction: column;
        padding-left: 70px;
    }
    .screen-opale{
       display: none;
    }
    .une-info--modes,
    .une-info--lieux,
    .une-info--pokemon,
    .une-info--difficultes{
        display: none;
    }
    #modes-mode:checked ~ .infos-container .une-info--modes,
    #modes-mode:checked ~ .pokedex .screen-opale--mode,
    #modes-lieux:checked ~ .infos-container .une-info--lieux,
    #modes-lieux:checked ~ .pokedex .screen-opale--lieux,
    #modes-pokemon:checked ~ .infos-container .une-info--pokemon,
    #modes-pokemon:checked ~ .pokedex .screen-opale--pokemon,
    #modes-difficultes:checked ~ .infos-container .une-info--difficultes,
    #modes-difficultes:checked ~ .pokedex .screen-opale--difficultes{
        display: block;
    }
    .input-modes{
        display:none;
    }
    .screen-opale--1{
        animation: afficher-1 10s infinite;
    }
    .screen-opale--2{
        animation: afficher-2 10s infinite;
    }
    .screen-opale--3{
        animation: afficher-3 10s infinite;
    }
    .cta-container:after{
        content: '';
        background-image: url(/public/images/arrow_right.svg);
        display: none;
        position: absolute;
        width: 40px;
        height: 50px;
        margin-top: 10px;
        background-repeat: no-repeat;
        background-size: contain;
        left: -50px;
        top: -13px;
    }
    #modes-lieux:checked        ~ .infos-container .cta-container--lieux:after,
    #modes-mode:checked         ~ .infos-container .cta-container--modes:after,
    #modes-pokemon:checked      ~ .infos-container .cta-container--pokemon:after,
    #modes-difficultes:checked  ~ .infos-container .cta-container--difficultes:after{
        display: block;
    }

    .view-container.infos{
        background-image: url(/public/images/background2.jpg);
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        display: flex;
        height: 70vh;
        justify-content: center;
        align-items: center;
        position: relative;
    }


    .pokedex-slider {
        width: 100%;
        height: 100%;
        position: relative;
        overflow: hidden;
    }

    .poke-img {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 256px;  /* ← nouvelle largeur */
        transform: translate(-50%, -50%) translateX(100%);
        transition: transform 0.5s ease-in-out;
    }


    @keyframes clignotement {
        0% {
            opacity: 1;
        }
        50% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
    @keyframes defilement {
        0% {
            transform: translateX(-25%);
        }
        100% {
            transform: translateX(25%);
        }
    }
    @keyframes afficher-1 {
        0% {
            opacity: 1;
        }
        32% {
            opacity: 1;
        }
        33% {
            opacity: 0;
        }
        100% {
            opacity: 0;
        }
    }
    @keyframes afficher-2 {
        0% {
            opacity: 0;
        }
        32% {
            opacity: 0;
        }
        33% {
            opacity: 1;
        }
        65% {
            opacity: 1;
        }
        66% {
            opacity: 0;
        }
        100% {
            opacity: 0;
        }
    }
    @keyframes afficher-3 {
        0% {
            opacity: 0;
        }
        65% {
            opacity: 0;
        }
        66% {
            opacity: 1;
        }
        100% {
            opacity: 1;
        }
    }
    @media screen and (max-width: 1600px){
        .view-content{
            flex-direction: column;
            gap: 20px;
            padding-bottom: 50px;
        }
        .infos-container{
            flex-direction: column;
            gap: 20px;
            padding: 20px;
            width: calc(100% - 100px);
        }
        .une-info{
            width: 100%;
            max-width: calc(100% - 100px);
        }
        .zone-cta-info{
            display: flex;
            gap: 20px;
            padding-left: 70px;
            align-content: space-between;
            flex-direction: row;
            justify-content: space-between;
        }
        .zone-cta-info{
            display: flex;
            gap: 20px;
            padding-left: 70px;
            align-content: space-between;
            flex-direction: row;
            justify-content: space-between;
            width: calc(100% - 70px);
        }
    }
    @media screen and (max-width: 1600px){
        .view-container.infos{
            height: auto !important;
        }
    }
    @media screen and (max-width: 1200px){
        .infos-container{
            padding: 20px;
            width: calc(100% - 0px);
        }
        .zone-cta-info{
            padding-left: 40px;
            width: calc(100% - 70px);
        }
        .cta-container:after{
            left: -35px;
        }

        .view-container{
            width:100% !important;
        }
        
        .view-content{
            width:100% !important;
        }
        .Presentation-texte, .view-content, .view-container{
            border:none;
            border-radius: 0;
        }
        .une-info{
            border: none;
            border-radius: 0;
        }
    }

    @media screen and (max-width: 1000px){
        .zone-cta-info[data-v-393ad305] {
            padding-left: 70px;
            align-content: space-between;
            flex-direction: column;
            flex-wrap:wrap;
        }
        .infos-container{
            overflow: hidden;
        }
    }

    @media screen and (max-width: 900px){
        .pokedex-img{
            display: none;
        }
        .pokedex {
            left: 0px;
            width: 100%;
            height: fit-content;
        }
        .screen-pokedex{
            width: 80%;
            margin: auto;
            left: 0;
            right: 0;
            top: 20px;
            position: relative;
            width: 269px;
            height: 302px;
        }
        .view-container{
            padding-bottom: 20px;
            padding-top:20px;
        }
        .screen-opale{
            border: solid 3px #000000;
            left: -5px;
            outline: solid 10px #d51f3f;
        }
        .titre-pokeball{
            flex-wrap: wrap;
        }
        .une-info{
            padding: 50px;
        }
        .cta-container{
            width: calc(100% - 70px);
            padding-left:0 !important;
        }
        .cta{
            width: calc(100% - 70px);
            left: 0;
        }
        .zone-cta-info{
            padding-left: 70px;
            align-content: space-between;
            flex-direction: column;
            flex-wrap: wrap;
            width: 100%;
            max-width: 100%;
        }
        .cta-container::after{
            display: none !important;
        }
        #modes .view-content{
            padding:0;
        }
        .pokedex{
            margin-bottom: 50px;
            background: #d51f3e;
            width: -moz-fit-content;
            width: fit-content;
            padding: 10px 26px 20px;
            border: solid 2px black;
            border-radius: 20px;
            -webkit-box-shadow: inset 0px 0px 0px 6px #692828;
            box-shadow: inset 0px 0px 11px 5px #771c1c;
            margin-bottom: 0px;
            margin-top: 20px;
        }
        
        .screen-pokedex{
            border: solid 11px;
            margin-bottom: 25px;
            width: 269px;
            height: 302px;
            box-shadow: inset 0px 0px 0px 6px #b5b5b5;
        }

         .une-info{
            background: white;
            padding: 20px;
            border: solid 2px black;
         }

         .view-content{
            display: flex;
            flex-direction: column-reverse;
         }
    }
</style>